import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { ConvenioService } from '../../../../providers/convenio-service';
import { AlertService } from '../../../../providers/alert-service';

@Component({
    selector: 'page-modal-pv-convenios',
    templateUrl: 'modal-pv-convenios.html'
})
export class ModalPreVisualizarConveniosPage {
    titulo: any;
    isJurisdicionado: any;
    listaDados: any;
    listaDadosBaixa: any = [];
    listaDadosReincidencia: any = [];
    listaDadosOutros: any = [];
    dataGeracao: any;
    loading: boolean = true;
    shownGroup: any = [];

    constructor(private viewCtrl: ViewController,
        public navParams: NavParams,
        public convenioService: ConvenioService,
        public alertService: AlertService,
        public alertCtrl: AlertController,
        public gestaoPcaService: GestaoPcaService) {

        this.dataGeracao = new Date();

        this.listarDados();
    }

    diferenca(val1, val2) {
        let res = val1 - val2;

        return this.formatarValorNumerico(res);
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    listarDados() {
        this.convenioService.obterPreviewCertificado().subscribe(
            data => {
                this.listaDados = data;

                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            }
        );
    }

    //  #region Métodos do Accordion
    toggleGroup(group) {
        if (this.isGroupShown(group)) {
            let index = this.shownGroup.indexOf(group);
            this.shownGroup.splice(index, 1);
        } else {
            this.shownGroup.push(group);
        }
    }

    isGroupShown(group) {
        return this.shownGroup.indexOf(group) != -1;
    };

    formatarValorNumerico(valor) {
        if (isNaN(valor)) {
            valor = 0;
        }

        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 1;

        if (text != undefined) {
            let separatedByWords = text.split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        if (text != undefined && text !== "N/A") {

            let separatedByWords = text.split(" ");
            let numberOfWordsToTruncate = 1;

            return separatedByWords.length >= numberOfWordsToTruncate;
        }
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/convenios/modal-pv-convenios.ts